import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { EntityProvider } from "@/lib/entityStore";
import AppShell from "@/components/shell/AppShell";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import GroupView from "@/pages/GroupView";
import Entities from "@/pages/Entities";
import EntityDashboard from "@/pages/EntityDashboard";
import Cashflow from "@/pages/Cashflow";
import Debtors from "@/pages/Debtors";
import Payables from "@/pages/Payables";
import AuditFindings from "@/pages/AuditFindings";
import AIExpert from "@/pages/AIExpert";
import Reports from "@/pages/Reports";
import Connections from "@/pages/Connections";
import Settings from "@/pages/Settings";
import Briefings from "@/pages/Briefings";
import Reconciliation from "@/pages/Reconciliation";
import Patterns from "@/pages/Patterns";
import Forecast from "@/pages/Forecast";
import Notes from "@/pages/Notes";
import ProductionReadiness from "@/pages/ProductionReadiness";
import { Privacy, Terms } from "@/pages/Legal";

function Protected({ children }) {
    const { token, loading } = useAuth();
    if (loading) return null;
    if (!token) return <Navigate to="/login" replace />;
    return children;
}

function App() {
    return (
        <AuthProvider>
            <EntityProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route
                            element={
                                <Protected>
                                    <AppShell />
                                </Protected>
                            }
                        >
                            <Route path="/" element={<Overview />} />
                            <Route path="/group" element={<GroupView />} />
                            <Route path="/entities" element={<Entities />} />
                            <Route
                                path="/entities/:entityId"
                                element={<EntityDashboard />}
                            />
                            <Route path="/cashflow" element={<Cashflow />} />
                            <Route path="/debtors" element={<Debtors />} />
                            <Route path="/payables" element={<Payables />} />
                            <Route path="/audit" element={<AuditFindings />} />
                            <Route path="/ai-expert" element={<AIExpert />} />
                            <Route path="/reports" element={<Reports />} />
                            <Route path="/briefings" element={<Briefings />} />
                            <Route path="/reconciliation" element={<Reconciliation />} />
                            <Route path="/patterns" element={<Patterns />} />
                            <Route path="/forecast" element={<Forecast />} />
                            <Route path="/notes" element={<Notes />} />
                            <Route
                                path="/production-readiness"
                                element={<ProductionReadiness />}
                            />
                            <Route
                                path="/connections"
                                element={<Connections />}
                            />
                            <Route path="/settings" element={<Settings />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Toaster position="top-right" />
                </BrowserRouter>
            </EntityProvider>
        </AuthProvider>
    );
}

export default App;
